import clsx from 'clsx'
import type { ButtonHTMLAttributes, ReactNode } from 'react'

const variants = {
  primary: 'stryzh-btn--primary',
  secondary: 'stryzh-btn--secondary',
  /** то же, что secondary — outline (ADMIN_UX v3 п.10) */
  outline: 'stryzh-btn--secondary',
  ghost: 'stryzh-btn--ghost',
  danger: 'stryzh-btn--danger',
  /** управляющие действия над сущностью (палитра лида) — бирюзовый Carlink */
  control: 'stryzh-btn--control',
}

export function Button({
  className,
  variant = 'secondary',
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: keyof typeof variants
  children: ReactNode
}) {
  return (
    <button
      type="button"
      className={clsx(
        'stryzh-btn',
        variants[variant],
        'disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  )
}
